<template>
    <div>
        <span :class="timerclass">{{timestr}}</span>

    </div>

</template>

<script>

  export default {
      name: "timer",
      props:{
        timeStart: String,
        timeEnd: String,
        title: String
      },

      mounted() {

          this.interval = setInterval(() => {
              this.timer()
          }, 1000);
      },

      components:{

       },

      data() {
          return {
              timestr : '',
              timerclass : '',
              interval: null

          }
      },

      beforeDestroy() {
          // prevent memory leak
          clearInterval(this.interval)
      },


      computed: {
          _timestart: function(){
            return Date.parse(this.timeStart.replace(' ','T'));
          },

          _timeend: function(){
              try
              {
                  return Date.parse(this.timeEnd.replace(' ','T'));
              }
              catch (err)
              {
                  return new Date();
              }

          },

      },

     methods:{

         timer :function() {

             let today = new Date();
             let now = Date.now();
             if (now>this._timeend)
             {
                this.timestr = this.title + " завешено "+this.timeEnd;
                this.timerclass = 'complite p-2 mb-4';
             }
             else if (now < this._timestart)
             {
                 today = Math.floor((this._timestart-today)/1000);
                 let tsec = today%60; today=Math.floor(today/60); if(tsec<10)tsec='0'+tsec;
                 let tmin = today%60; today=Math.floor(today/60); if(tmin<10)tmin='0'+tmin;
                 let thour = today%24; today=Math.floor(today/24);

                 if (today>0)
                 {
                     this.timestr = this.title + " почнеться через "+today +" дн. "+ thour+" год. "+tmin+" хв. "+tsec+" сек.";
                 }
                 else
                 {
                     this.timestr = this.title + " почнеться через "+ thour+" год. "+tmin+" хв. "+tsec+" сек.";
                 }

                 this.timerclass = 'infuture p-2 mb-4';

             }
             else
             {
                 today = Math.floor((this._timeend-today)/1000);
                 let tsec=today%60; today=Math.floor(today/60); if(tsec<10)tsec='0'+tsec;
                 let tmin=today%60; today=Math.floor(today/60); if(tmin<10)tmin='0'+tmin;
                 let thour=today%24; today=Math.floor(today/24);
                 if (today>0)
                 {
                     this.timestr = this.title + " завершиться через "+today +" дн. "+ thour+" год. "+tmin+" хв. "+tsec+" сек.";
                 }
                 else
                 {
                     this.timestr = this.title + " завершиться через "+ thour+" год. "+tmin+" хв. "+tsec+" сек.";
                 }
                 this.timerclass = 'nowactive p-2  mb-4';

             }

         }


     }

 }

</script>


